import { avatar } from "@/assets";
import { FaEye, FaRegUser } from "react-icons/fa6";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import { useEffect, useState } from "react";
import { useTheme } from "@/hooks/useTheme";

import { Link } from "react-router-dom";
import { remoteAddress } from "@/constants";
import UploadPhoto from "./tabs/UploadPhoto";
import DarkMode from "./tabs/DarkMode";
import ContactUs from "./tabs/ContactUs";
import DeactivateAccount from "./tabs/DeactivateAccount";
import { useSelector } from "react-redux";
import { resolveImageUrl } from "@/lib/utils";

const SiteFunctions = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (theme === "dark") {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [theme]);

  return (
    <section className="text-black/85 dark:text-white">
      <div
        className="relative h-[17vh]"
        style={{
          background:
            "linear-gradient(rgb(37 99 235), rgb(37 99 235)), url('/src/assets/pattern.png')",
          backgroundBlendMode: "overlay",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute -bottom-10 left-6">
          <img
            src={user.avatar ? resolveImageUrl(user.avatar) : avatar}
            alt="avatar"
            className="size-20 rounded-full object-cover"
          />
        </div>
      </div>

      <div className="flex flex-col gap-3 px-5 pt-12">
        <div>
          <h2 className="font-geist text-2xl font-bold">
            {user.name}
            {/* Christopher John */}
          </h2>
          <p className="dark:text-darkGray text-gray-500">
            {user?.email}
            {/* christopher20@gmail.com */}
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold text-gray-500 dark:text-gray-50">
            General settings
          </p>

          <div className="flex flex-col gap-3 pt-2">
            {/* Upload Image */}
            <UploadPhoto />

            {/* Account Settings */}
            <Link
              to="/dashboard/account"
              onClick={() => scrollTo(0, 0)}
              className="flex cursor-pointer items-center gap-2"
            >
              <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
                <FaRegUser size={20} className="text-primary" />
              </div>

              <div>
                <h1 className="font-semibold">Account Settings</h1>
                <p className="dark:text-darkGray text-[12px] font-medium text-gray-500">
                  Manage profile
                </p>
              </div>
            </Link>

            {/* Dark Mode */}
            <DarkMode />

            {/* Contact */}
            <ContactUs />

            {/* Deactivate Account */}
            <DeactivateAccount />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SiteFunctions;
